/* jshint esversion: 6 */

function Responsive() {
    const _this = this;
    const w = window;
    const $w = $(w);
    _this.windowWidth = w.innerWidth;
    _this.delay = 50;


    _this.init = function () {
        if (_this.isMobile.any()) {
            _this.range = {
                all: [1660, Infinity],
                lg: [1366, 1659],
                md: [992, 1365],
                sm: [768, 991],
                xs: [0, 767],
            };
        }
        else {
            _this.range = {
                all: [1660, Infinity],
                lg: [1366, 1659],
                md: [992, 1365],
                sm: [751, 991],
                xs: [0, 750],
            };
        }

        $w.on('resize.kr', () => {
            clearTimeout(_this.resposiveDelay);
            _this.resposiveDelay = setTimeout(() => {
                if (w.innerWidth !== _this.windowWidth) {
                    _this.windowWidth = w.innerWidth;
                    _this.triggers();
                }
            }, _this.delay);
        });

        _this.activeRange = _this.getRange();

        setTimeout(() => {
            $w.trigger(`kr.${_this.activeRange}`);
            _this._triggerUp();
            _this._triggerDown();
        }, 1);


        w.kr = {
            is: _this.isRange,
            isLowerThan: _this.isLowerThan,
            isHigherThan: _this.isHigherThan,
            getRange() {
                return _this.activeRange;
            },
            get(range) {
                return _this.range[range];
            }
        };

    };



    _this.isLowerThan = function (range) {
        return (_this.range[range][0] > _this.windowWidth);
    };

    _this.isHigherThan = function (range) {
        return (_this.range[range][1] < _this.windowWidth);
    };

    _this.isRange = function (range) {
        return (_this.windowWidth >= _this.range[range][0] && _this.windowWidth <= _this.range[range][1]);
    };

    _this.getRange = function () {
        let match = 'all';
        $.each(_this.range, key => {
            if (_this.isRange(key)) {
                match = key;
            }
        });
        return match;
    };

    _this._triggerUp = function () {
        $.each(_this.range, (key, range) => {
            try {
                if (_this.range[_this.activeRange][1] < range[0]) {
                    $w.trigger(`kr.${key}.down`);
                }
            }
            catch (err) {
                $w.trigger(`kr.${key}.down`);
            }
        });
    };

    _this._triggerDown = function () {

        $.each(_this.range, (key, range) => {
            try {
                if (_this.range[_this.activeRange][0] > range[1]) {
                    $w.trigger(`kr.${key}.up`);
                }
            }
            catch (err) {
                $w.trigger(`kr.${key}.up`);
            }
        });
    };

    _this.triggers = function () {
        const tempRange = _this.getRange();

        if (tempRange !== _this.activeRange) {
            _this.activeRange = tempRange;
            $w.trigger(`kr.${_this.activeRange}`);
            _this._triggerUp();
            _this._triggerDown();
        }
    };

    _this.isMobile = {
        Android() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any() {
            return (_this.isMobile.Android() || _this.isMobile.BlackBerry() || _this.isMobile.iOS() || _this.isMobile.Opera() || _this.isMobile.Windows());
        }
    };

    _this.init();
}

const responsive = new Responsive();

export default responsive;
